<template>
  <v-container fluid grid-list-xl page>
    <v-layout row wrap>
      <v-flex xs12 sm8 md12>
        <section-header v-text="page.headline"></section-header>
        <div class="subheading justify" v-html="page.description"></div>
        <div class="my-5"></div>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 sm12>
        <span
          class="header"
        >Elige el pack de prepago que se adapta mejor a tus necesidades. En cuuanto pagues podrás comenzar a hacr uso del servicio. Puedes comprar tantos packs como vayas necesitando, los créditos se irán sumando a los que teengas en el momento de la compra</span>
      </v-flex>
      <v-card class="elevation-4 border-radius6">
        <v-toolbar card dense color="transparent">
          <v-toolbar-title>
            <h4>Packs</h4>
          </v-toolbar-title>
        </v-toolbar>
        <v-divider></v-divider>
        <v-card-text class="pa-0">
          <v-expansion-panel popup>
            <v-expansion-panel-content v-for="(ticket, i) in products" :key="i" hide-actions>
              <v-layout slot="header" align-center row spacer>
                <v-flex xs6 sm4>
                  <v-chip
                    v-if="ticket.new"
                    :color="`${ticket.color} lighten-4`"
                    class="ml-0"
                    label
                    small
                  >{{ ticket.new }} new</v-chip>
                  <strong v-html="ticket.name"></strong>
                </v-flex>

                <v-flex sm4 md3 hidden-xs-only>
                  <strong v-html="ticket.price"></strong>
                                    <strong> €</strong>

                </v-flex>

                <v-flex>
                  <v-chip
                    color="error"
                    small
                    @click="selectPackage(i)"
                    text-color="white"
                  >Selecciona esta opción</v-chip>
                </v-flex>
              </v-layout>

              <v-card v-if="chosen">
                <v-card-text>
                  <PayPal
                    :amount="selectedProduct.price"
                    currency="€"
                    :client="credentials"
                    env="sandbox"
                    v-on:payment-authorized="paymentAuthorized"
                    v-on:payment-completed="paymentCompleted"
                    v-on:payment-cancelled="paymentCancelled"
                  ></PayPal>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-card-text>
      </v-card>
      <v-flex xs12 sm12 >
      <div xs12 sm12 >
      <v-btn xs12 sm12 round color="orange darken-4" dark bold outline
      @click="gotoProfile">Volver a Mi Cuenta</v-btn>
      </div>
      </v-flex>
      <!--
    <v-card v-if="chosen">
      <v-card-text>
        <PayPal amount="10.00" currency="USD" :client="credentials" env="sandbox"></PayPal>
      </v-card-text>
    </v-card>
      -->
    </v-layout>
  </v-container>
</template>
<script>
import PayPal from "vue-paypal-checkout";

export default {
  components: {
    PayPal
  },
  mounted() {
    // Google Analytics
    // this.$ga.page(this.$router);
    var productsRef = this.$db.collection("products");
    const self = this;
    var res = productsRef.where("price", ">", 0).get().then(snapshot => {
      if (snapshot.empty) {
        console.log("No matching documents." + res);
        return;
      }
      snapshot.forEach(doc => {
        console.log(doc.id, "=>", doc.data());
        self.products.push(doc.data());
      });
    })
    .catch(err => {
      console.log("Error getting documents", err);
    });
  },
  data() {
    return {
      page: {
        title: "Comprar Créditos ",
        headline: "Comprar Créditos",
        description: `Adquiere créditos por prepago`
      },
      breadcrumbs: [
        {
          text: "Src",
          disabled: false
        },
        {
          text: "Views",
          disabled: false
        },
        {
          text: "Blank",
          disabled: false
        }
      ],
      credentials: {
        sandbox:
          "AVnhqOyru5OY3WTwsPdtSQKN9Oq1yph6GB71eoRelFct77ZemInjrXE5e50CG3BbMb-Ko1cKMWkiAHUG",
        production: "<production client id>"
      },
      products: [],
      selectedProduct: {},
      chosen: false
    };
  },
  methods: {
    selectPackage(pck) {
      this.selectedProduct = this.products[pck];
      this.chosen = true;
    },
    paymentAuthorized: function(data) {
      console.log(data);
    },
    paymentCompleted: function(data) {
      console.log(data);
    },
    paymentCancelled: function(data) {
      console.log(data);
    },

    gotoProfile() {
      this.$router.push({ name: "ProfilePage" });
    }
  }
};
</script> 
